import { colorSchemes } from '@features/campaigns/subdomains/visitation/utils';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Stack, Typography } from '@mui/material';
import { DARK_GRAY_COLOR } from '@utils/colorGenerator';
import { ConfidenceLevel } from '../ConfidenceLevel';

const SMALL_ICON_SIZE = '2.5rem';
const LARGE_ICON_SIZE = '3rem';

type ColorScheme = keyof typeof colorSchemes;

export type HeroMetricProps = {
  value: number | null;
  valueFormatter: (value: number | null) => string;
  confidenceLevel?: number | null;
  label: string;
  colorScheme: ColorScheme;
  icon?: IconProp;
  size?: 'sm' | 'lg';
  ['data-testid']?: string;
};

export const HeroMetric = (props: HeroMetricProps) => {
  return (
    <Stack
      direction="row"
      spacing="0.5rem"
      alignItems="center"
      data-testid={props['data-testid']}
    >
      {props.icon ? (
        <Box
          display="flex"
          alignItems="center"
          height={props.size === 'sm' ? SMALL_ICON_SIZE : LARGE_ICON_SIZE}
          width={props.size === 'sm' ? SMALL_ICON_SIZE : LARGE_ICON_SIZE}
          justifyContent="center"
          borderRadius={1}
          sx={{ backgroundColor: colorSchemes[props.colorScheme].background }}
        >
          <FontAwesomeIcon
            icon={props.icon}
            color={colorSchemes[props.colorScheme].text}
            size={props.size}
          />
        </Box>
      ) : null}

      <Stack direction="column" justifyContent="center" gap="0.25rem">
        <Stack direction="row" alignItems="center" spacing="0.5rem">
          <Typography
            fontWeight="bold"
            fontSize={props.size === 'sm' ? 'h6.fontSize' : 'h4.fontSize'}
          >
            {props.valueFormatter(props.value)}
          </Typography>

          <ConfidenceLevel value={props.confidenceLevel} lift={props.value} />
        </Stack>

        <Typography color={DARK_GRAY_COLOR} lineHeight={1}>
          {props.label}
        </Typography>
      </Stack>
    </Stack>
  );
};
